const { DEAL_STATUS } = require('../../constants/DealConstants');

const UNAVAILABLE_DEAL_STATUSES = [DEAL_STATUS.NA, DEAL_STATUS.FAIL];

// Hotel-level prices come from the results list and could outrank the room the page actually shows.
const HOTEL_PRICE_FIELDS = [
    'total_price',
    'totalPrice',
    'price_per_night',
    'pricePerNight',
    'currency',
    'representativeDeal',
    'representative_deals',
];

const isPricedDeal = (deal) => {
    if (!deal || deal.not_available || deal.faultDeal || UNAVAILABLE_DEAL_STATUSES.includes(deal.status)) {
        return false;
    }

    // A shown total of 0 is still a price; null and empty values would coerce to 0, so they are excluded.
    const totalPrice = Number(deal.totalPrice);
    return deal.totalPrice !== null && deal.totalPrice !== '' && Number.isFinite(totalPrice) && totalPrice >= 0;
};

// Callers pass the deals in the order the room list renders them.
const getFirstPricedDeal = (shownDeals) => (Array.isArray(shownDeals) && shownDeals.find(isPricedDeal)) || null;

// The hotel view is priced only by the room the page shows first; without one it is sent unpriced.
const buildHotelViewDestination = (hotel, deal) => {
    if (!hotel) {
        return hotel;
    }

    const destination = {};
    Object.keys(hotel).forEach((key) => {
        if (!HOTEL_PRICE_FIELDS.includes(key)) {
            destination[key] = hotel[key];
        }
    });

    return deal ? { ...destination, representativeDeal: deal } : destination;
};

module.exports = {
    isPricedDeal,
    getFirstPricedDeal,
    buildHotelViewDestination,
};
